import {
  StaffNotificationsResponseSchema,
  StaffUnreadNotificationsResponseSchema,
  type StaffNotificationsResponse,
  type StaffUnreadNotificationsResponse,
} from '@/features/notifications/api/staff-notifications.schemas.js';
import { getHttpClient } from '@/shared/api/http-client.js';

export function staffNotificationsApiPath(suffix = ''): string {
  return `/api/notifications${suffix}`;
}

export async function listStaffNotifications(query?: {
  cursor?: string;
  limit?: number;
}): Promise<StaffNotificationsResponse> {
  const params = new URLSearchParams();
  if (query?.cursor) {
    params.set('cursor', query.cursor);
  }
  if (query?.limit) {
    params.set('limit', String(query.limit));
  }
  const suffix = params.size > 0 ? `?${params.toString()}` : '';
  const raw = await getHttpClient().get<unknown>(staffNotificationsApiPath(suffix));
  return StaffNotificationsResponseSchema.parse(raw);
}

export async function getUnreadStaffNotificationCount(): Promise<StaffUnreadNotificationsResponse> {
  const raw = await getHttpClient().get<unknown>(staffNotificationsApiPath('/unread-count'));
  return StaffUnreadNotificationsResponseSchema.parse(raw);
}

export async function markStaffNotificationRead(notificationId: string): Promise<void> {
  await getHttpClient().post<unknown>(staffNotificationsApiPath(`/${notificationId}/read`));
}

export async function dismissStaffNotification(notificationId: string): Promise<void> {
  await getHttpClient().delete<unknown>(staffNotificationsApiPath(`/${notificationId}`));
}
